export const defaultSeatValues = {
  academicyear: { value: "AY202526", label: "AY202526" },
  board: { value: "JOSAA", label: "JOSAA" },
  round: { value: "CAPR0", label: "CAPR0" },
  quota: { value: "AI", label: "AI" },
  category: { value: "OPEN", label: "OPEN" },
  gender: { value: "GENDER-NEUTRAL", label: "GENDER-NEUTRAL" },

};
export const defaultSeatSearch = {
  academicyear: "AY202526",
  board: "JOSAA",
  round: "CAPR0",
  quota: "AI",
  category:"OPEN",
  gender: "GENDER-NEUTRAL",
};
export const mainSeatList = ["academicyear", "board", "round", "quota", "category",'gender'];